namespace GeniuzPOS.Lookups {
    export namespace PsPosShiftStatusService {
        export const baseUrl = 'Lookups/PsPosShiftStatus';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPosShiftStatusRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPosShiftStatusRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/PsPosShiftStatus/Retrieve",
            List = "Lookups/PsPosShiftStatus/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPosShiftStatusService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
